<script lang="jsx">
import { mapActions } from 'vuex';
import mixin from '@/plans/mx/shopping-cart';
// import { planTypes } from '@/common/constants';
//import { DEFAULT_FREE_TRIAL_DAYS } from '@/common/constants';

/**
 * BONSAI free trial - custom cart content for SIGN view.
 * Only shows free trial line: title, trial duration, license, start date, remove.
 */
export default {
  mixins: [mixin],
  name: 'BonsaiCart',
  computed: {
    bonsaiTitle() {
      return this.$t('billing.planform.title.bonsai_ft');
    },
  },
  methods: {
    ...mapActions(['removePlanByKey']),
    $renderPrice() {
      return (
        <div class="opc-cart-item opc-cart-item--bonsai-freetrial">
          <div>
            {this.mx_title(this.bonsaiTitle, this.$money(0, { customizedCurrencySymbol: '$' }))}
            <div class="opc-cart-item__text opc-cart-item__cycle">
              {this.$t('billing.planform.bonsai.unlimited_users')}
            </div>
          </div>
        </div>
      );
    },
    $renderTip() {
      return <div class="opc-cart-item__text"></div>;
    },
    $renderAgreement() {
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
.opc-cart-item__agreement--bonsai {
  font-size: 14px;
  line-height: 1.5;
  color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
}
.opc-cart-item__agreement-link {
  color: var(--zoom-color-primary, #0e72ed);
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}
</style>
